import Bugsnag from '@bugsnag/js';
import { message } from 'ant-design-vue';
import useClipboard from 'vue-clipboard3';

import type { Maybe } from '@/graphql/generated/graphql';

const useCopytoClipboard = () => {
  const { toClipboard } = useClipboard();
  const onCopy = async (text?: Maybe<string>) => {
    try {
      if (text) {
        await toClipboard(text);
        message.success('Copied to clipboard');
      } else {
        message.error('Nothing to copy');
      }
    } catch (error) {
      message.error('Error: It could not be copied');
      Bugsnag.notify(error as Error);
    }
  };
  return {
    onCopy,
  };
};

export default useCopytoClipboard;
